import { createSvgComponent } from "../../icon/createSvgComponent";
import SearchBook from "@core/__generated__/icon/figma/search-book.svg";
export default createSvgComponent(SearchBook);